module.exports = __webpack_public_path__ + "img/用车明细表示例2.422478ac.png";